var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAudioPlayBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19218",
    "data-name": "Rectangle 19218",
    width: 25.675,
    height: 20,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69653",
    "data-name": "Group 69653",
    transform: "translate(21835 19312)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10508",
    "data-name": "Ellipse 10508",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(-21835 -19312)",
    fill: "#6b7992"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69635",
    "data-name": "Group 69635",
    transform: "translate(-21827.838 -19302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69634",
    "data-name": "Group 69634",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155635",
    "data-name": "Path 155635",
    d: "M12.826,19.437a1.162,1.162,0,0,1-.763-.284L6.316,14.181H1.166A1.166,1.166,0,0,1,0,13.015V6.347A1.166,1.166,0,0,1,1.166,5.182H6.4l5.662-4.9a1.165,1.165,0,0,1,1.929.881v17.1a1.164,1.164,0,0,1-1.166,1.166",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155636",
    "data-name": "Path 155636",
    d: "M19.1,20a1.166,1.166,0,0,1-.908-1.9,12.863,12.863,0,0,0,0-16.207A1.166,1.166,0,1,1,20.01.437a15.18,15.18,0,0,1,0,19.127A1.162,1.162,0,0,1,19.1,20m-4.242-2.331a1.165,1.165,0,0,1-.937-1.857,9.693,9.693,0,0,0,0-11.559A1.166,1.166,0,1,1,15.8,2.869a12.013,12.013,0,0,1,0,14.325,1.165,1.165,0,0,1-.94.475",
    transform: "translate(2.273 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioPlayBlue);
export default __webpack_public_path__ + "static/media/icon-audio-play-blue.4e7b6537a663a4285182c2ae369ac966.svg";
export { ForwardRef as ReactComponent };